import React from "react";
import IncidentLog from "./IncidentLogs";

const CreateIncidentLogs = (props) => {
  return <IncidentLog />;
};

export default CreateIncidentLogs;